// extracted by mini-css-extract-plugin
module.exports = {"copyrightText":"CopyrightDisplay_copyrightText__dqhkm"};